function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "20",
  fill: "#4462FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.95 11l-1.42 2.19 1.42 2.21h-.01l-1.99 3.1-1.73-.9 1.42-2.21-1.42-2.2 2-3.1 1.73.91zm6-.11l-1.42 2.21 1.42 2.2-.01.01-1.99 3.09-1.73-.9 1.42-2.2-1.42-2.2 2-3.1 1.73.89zm6.05 0l-1.44 2.21L28 15.3v.01l-2 3.09-1.75-.9 1.42-2.2-1.42-2.2 2-3.1 1.75.89zM10 30v-8a2 2 0 012-2h16a2 2 0 012 2v8h-2v-2H12v2h-2zm4-8a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
  fill: "#fff"
}));